import { useLingui } from '@lingui/react/macro'
import { AccountMenuChoice } from 'features/navbar/AccountMenuChoice'
import { useGeckoPermissions } from 'features/permissions'
import React from 'react'

export const PermissionGateToggle: React.FC = () => {
  const { showPermissionGates, setShowPermissionGates } = useGeckoPermissions()
  const { t } = useLingui()

  return (
    <AccountMenuChoice
      label={t`Permission Gates`}
      value={showPermissionGates ? 'show' : 'hide'}
      onValueChange={(value) => setShowPermissionGates(value === 'show')}
      options={[
        {
          value: 'hide',
          label: t`Hide`,
          accessibleLabel: t`Hide permission gates`,
        },
        {
          value: 'show',
          label: t`Show`,
          accessibleLabel: t`Show permission gates`,
        },
      ]}
    />
  )
}
